import { IconChevronsLeft, IconChevronsRight } from "@/assets/icons";
import { isNumber } from "@/utils/number";
import { Pagination as MuiPagination, PaginationItem, Stack, styled } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

type Props = {
  totalPage?: number;
  count?: number;
};

export const Pagination: FC<Props> = ({ totalPage }) => {
  const { pathname, search } = useLocation();

  const query = new URLSearchParams(location.search);
  const page = parseInt(query.get("page") || "1");

  const [_displayTotalPage, setDisplayTotalPage] = useState<number>(1);

  useEffect(() => {
    if (isNumber(totalPage)) {
      setDisplayTotalPage(totalPage > 0 ? totalPage : 1);
    }
  }, [totalPage]);

  return (
    <Stack direction="row" alignItems="center" gap={2.5}>
      <StyledPagination
        page={page}
        count={totalPage}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        renderItem={(item) => {
          const searchParams = new URLSearchParams(search);
          searchParams.set("page", item.page?.toString() ?? "1");

          // if (["page", "end-ellipsis", "start-ellipsis"].includes(item.type)) return null;

          return (
            <PaginationItem
              component={Link}
              to={{ pathname, search: searchParams.toString() }}
              slots={{ first: IconChevronsLeft, last: IconChevronsRight }}
              {...item}
            />
          );
        }}
      />
    </Stack>
  );
};

const StyledPagination = styled(MuiPagination)(() => ({
  "& .MuiPaginationItem-root": {
    border: "2px solid #cfd4d9",
    borderRadius: 8,
    minWidth: 40,
    height: 40,
    fontSize: 14,
    fontWeight: 500,
    color: "#4a4a4a",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
  },
  "& .MuiPaginationItem-root.Mui-selected": {
    backgroundColor: "#3a98a3",
    color: "#fff",
    border: "none",
    "&:hover": {
      backgroundColor: "#3a98a3",
    },
  },
  "& .MuiPaginationItem-ellipsis": {
    border: "2px solid transparent",
    minWidth: 48,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    fontWeight: 500,
    color: "#4a4a4a",
  },
  "& .MuiPaginationItem-root.Mui-disabled": {
    border: "2px solid transparent",
    backgroundColor: "#f2f2f2",
    color: "#b0b0b0",
    pointerEvents: "none",
  },
}));
